import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderService } from 'src/app/_services/dispo/order.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TeamBaseService } from 'src/app/_services/dispo/team-base';

@Component({
  selector: 'app-team-details',
  templateUrl: './team-details.component.html',
  styleUrls: ['./team-details.component.css']
})
export class TeamDetailsComponent implements OnInit {
  customerId='';
  customerObject: any;
  content?: string;
  isNew? : Boolean;
  constructor(
    private route: ActivatedRoute, 
    private router: Router,
    private toastr: ToastrService,
    private orderService: OrderService,
    private teamBaseService: TeamBaseService
    ) { }
    

  ngOnInit(): void {
    this.customerId = this.route.snapshot.params.id;
    this.teamBaseService.show(this.customerId).subscribe(
      data => {
        this.customerObject = data;
        this.isNew = this.teamBaseService.getIsNew();
      },
      err => {
        this.content = JSON.parse(err.error).message;
      }
    );
  }

  showModal = false;

  ngAfterContentInit() {
    this.showModal = true;
  }

  delete() {
    this.orderService.delete(this.customerObject).subscribe(
      data => {
        this.toastr.success('Daten erfolgreich gelöscht');
      },
      err => {
        this.content = JSON.parse(err.error).message;
      }
    );
  }

  goBack() {
    this.router.navigate(['../../'],{ relativeTo: this.route }).then(() => {});
  }

  onDialogClick(event: UIEvent) {
    // Capture click on dialog and prevent it from bubbling to the modal background.
    event.stopPropagation();
    event.cancelBubble = true;
  }

}
